module.exports = __webpack_public_path__ + "img/channel_icon_hover.71a12110.svg";